import { defaultActionCreator } from "../../actionCreator";

export const SET_STATE = "catchingArea/SET_STATE";
export const setState = defaultActionCreator(SET_STATE, "payload");

export const GET_CATCHING_AREA = "GET_CATCHING_AREA";
export const getCatchingArea = defaultActionCreator(GET_CATCHING_AREA, "param");
